import { IoIosMail } from "react-icons/io";
import { FaSquareInstagram } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useLocation } from "react-router-dom";
import facebookIcon from "../../assets/icons/facebook.png";
import whatsappIcon from "../../assets/icons/whatsapp.png";
import linkedinIcon from "../../assets/icons/linkedin.png";
import styles from "./footer.module.css";

export default function Footer() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? styles.active : "";

  return (
    <footer className={styles.footerSection}>
      <div className={styles.container}>

        <div className={styles.footerGrid}>

          {/* LEFT BLOCK */}
          <div className={styles.col}>
            <h2 className={styles.title}>9GRID DESIGN | ARCHITECTS.</h2>
            <p className={styles.desc}>We welcome you to connect with us to discuss your vision.</p>

            <div className={styles.col}>
              {/* Updated Header */}
              <h2 className={styles.title}>CONTACT:</h2>

              <div className={styles.contact}>
                {/* Line 1: New Project */}
                <div>
                  <p>for new project enquiry: </p>
                  <a href="mailto:info@9griddesign.com" style={{ textTransform: 'lowercase', color: 'white', fontWeight: '500', opacity: 1 }}>info@9griddesign.com</a>
                </div>

                {/* Line 2: Others */}
                <div>
                  <p>for others: </p>
                  <a href="mailto:info.9griddesign@gmail.com" style={{ textTransform: 'lowercase', color: 'white', fontWeight: '500', opacity: 1 }}>info.9griddesign@gmail.com</a>
                </div>

                <div>
                  <p>phone/whatsapp </p>
                  <a
                    href="https://wa.me/919088887799"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#fff', fontWeight: '500', opacity: 1 }}
                  >
                    +91 9088887799
                  </a>
                </div>

                {/* Line 4 & 5: Days and Time */}
                <div>
                  <b style={{ color: '#fff', fontWeight: '500', opacity: 1 }}>monday – friday</b>
                  <br />
                  <b style={{ color: '#fff', fontWeight: '500', opacity: 1 }}>11:00am – 7:00pm</b>
                </div>

                {/* Added Instagram Link */}
                {/* <p>
                  <a
                    href="https://www.instagram.com/9griddesign"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Follow us on Instagram
                  </a>
                </p> */}
              </div>
            </div>
          </div>

          {/* CENTER BLOCK */}
          <div className={styles.col}>
            <h2 className={styles.title}>QUICK LINKS</h2>
            <ul className={styles.links}>
              <li><a href="/" className={isActive("/")}>Home</a></li>
              <li><a href="/projects" className={isActive("/projects")}>Projects</a></li>
              <li><a href="/progress" className={isActive("/progress")}>Progress</a></li>
              <li><a href="/studio" className={isActive("/studio")}>Studio</a></li>
              <li><a href="/moments" className={isActive("/moments")}>Moments</a></li>
              <li><a href="/team" className={isActive("/team")}>Team</a></li>
              <li><a href="/success" className={isActive("/success")}>Success</a></li>
              <li><a href="/youtube" className={isActive("/youtube")}>YouTube</a></li>
              <li><a href="/contact" className={isActive("/contact")}>Contact</a></li>
            </ul>
          </div>

          {/* RIGHT BLOCK */}
          <div className={styles.col}>
            <h2 className={styles.title}>GET IN TOUCH</h2>
            <p className={styles.desc}>
              Have a question or project in mind? Drop us a message or email—we'd love to connect!
            </p>

            {/* Mail Button */}

            {/* Social Icons Row */}
            <div className={styles.socialRow}>
              <a href="mailto:info@9griddesign.com" target="_blank" rel="noopener noreferrer">
                <IoIosMail />
              </a>
              <a href="https://www.facebook.com/9griddesign" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" />
              </a>

              <a
                href="https://www.youtube.com/@9griddesign"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>


              <a href="https://www.instagram.com/9griddesign" target="_blank" rel="noopener noreferrer">
                <FaSquareInstagram />
              </a>

              <a
                href="https://wa.me/919088887799"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.whatsapp}
              >
                <img src={whatsappIcon} alt="WhatsApp" />
              </a>

              <a
                href="https://www.linkedin.com/company/9griddesign"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>

            </div>
          </div>
        </div>

        {/* COPYRIGHT LINE */}
        <div className={styles.bottom}>
          © 2013 9GRID DESIGN | TERMS OF SERVICE | PRIVACY POLICY
        </div>

      </div>
    </footer>
  );
}
